export const PARTIAL_MONTHLY_MENU_PAYMENT = 'partial-monthly-menu-payment';
